// extracted by mini-css-extract-plugin
export default {"icon":"ButtonSendChatHistory_icon__k25lo"};